
import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbPortaHub extends AppService {
  abstract getConfigSeguranca(): Observable<any>;
  abstract saveConfigSeguranca(configSeguranca: any): Observable<any>;
}